/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

// CHILDREN
import Placeholder from '../../../common/Placeholder'
import NoteRow from './NoteRow'

class CommunityNotes extends Component {
  renderNotes = () => {
    const { notes, toggleFormSection, deleteNote, toggleEditNote, t } = this.props

    if (notes && notes.length === 0) {
      return (
        <div className='col-md-8 mx-auto'>
          <Placeholder
            title={t('communities.notes.noNotesYet')}
            icon={'fa-clipboard'}
            subtext1={t('communities.notes.emptyStateSubtext1')}
            subtext2={t('communities.notes.emptyStateSubtext2')}
            buttonText={t('communities.notes.newNote')}
            buttonIcon={'fa-plus'}
            handleClick={() => toggleFormSection('notes')}
          />
        </div>
      )
    } else {
      return notes.map(note => (
        <NoteRow
          note={note}
          key={note.id}
          deleteNote={deleteNote}
          toggleEditNote={toggleEditNote}
        />
      ))
    }
  }

  render() {
    return <div id='CommunityNotes'>{this.renderNotes()}</div>
  }
}

export default withTranslation()(CommunityNotes)
